import { type Fabric, type FabricTextureStack, FabricSide } from '@seddi/scene';
import { type TSurfaceMaterial, SurfaceMaterialModel } from '@seddi/surface-material';
import { SHADING_MODEL_DEFAULT } from './materialConstants';

export type DoubleSideSurfaceMaterial = { back?: TSurfaceMaterial; front: TSurfaceMaterial };

/**
 * Converts fabric stack into surface material.
 * @param src - Fabric stack.
 */
export const adaptStack = (src: FabricTextureStack, thickness: number): TSurfaceMaterial => {
  return {
    id: src.id,
    model: src.model,
    name: src.name,
    params: src.params,
    repeat: { x: 1.0 / src.size.x, y: 1.0 / src.size.y },
    tags: ['FABRIC', `FABRIC_THICKNESS_${thickness}`],
  };
};

/**
 * Converts fabric into double sided surface material.
 * @param src - Fabric.
 * @param model - Preferred shading model.
 */
export const adapt = (
  src: Fabric,
  model: SurfaceMaterialModel = SHADING_MODEL_DEFAULT,
): DoubleSideSurfaceMaterial => {
  let back, front;

  for (const stack of src.textures) {
    if (stack.model === model) {
      switch (stack.fabricSide) {
        case FabricSide.BACK: {
          back = adaptStack(stack, src.thickness ? src.thickness : 0);
          break;
        }
        case FabricSide.FRONT: {
          front = adaptStack(stack, src.thickness ? src.thickness : 0);
          break;
        }
      }
    }
  }

  return { back, front };
};
